import React from "react";
import {
  Flame,
  GraduationCap,
  Sparkles,
  Globe2,
  Megaphone,
  MapPin,
} from "lucide-react";
import { Reveal, SectionHeading, TiltCard } from "./Atoms";

const HUBS = [
  { icon: Flame, t: "Prayer & Consecration", b: "Altars of intercession, fasting, and unbroken communion with God." },
  { icon: GraduationCap, t: "Training & Discipleship", b: "Equipping laborers in the Word, prayer, and the way of the Spirit." },
  { icon: Sparkles, t: "Deliverance & Healing", b: "Setting captives free through the authority of Jesus Christ." },
  { icon: Megaphone, t: "Revival & Evangelism", b: "Open-air preaching, soul winning, and reaching cities for Christ." },
  { icon: Globe2, t: "Apostolic Mobilization", b: "Sending equipped vessels into regions, nations, and harvest fields." },
  { icon: MapPin, t: "Regional Fire", b: "Local hubs raising up the next generation of revival carriers." },
];

const FireHubs = () => {
  return (
    <section id="fire-hubs" className="relative py-28 px-6 section-ember overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            overline="Fire Hubs & Revival Hubs"
            title={<>Altars of <span className="italic gold-text">consecration</span>. Not social clubs.</>}
            subtitle="Revival Fire Ministries Global is raising up Prophetic Revival Hubs and Fire Hubs across America and the nations — places of prayer, training, deliverance, discipleship, evangelism, and apostolic mobilization."
          />
        </Reveal>

        <Reveal delay={80}>
          <p className="max-w-3xl text-[#D9D9D9] text-[15px] leading-relaxed mb-12">
            The purpose of each Fire Hub is to gather believers around the presence of God,
            train laborers for the harvest, activate spiritual gifts, strengthen holiness
            and consecration, host revival gatherings, and release equipped vessels into
            their cities, regions, and nations.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {HUBS.map(({ icon: Icon, t, b }, i) => (
            <Reveal key={t} delay={i * 70}>
              <TiltCard strength={3}>
                <div className="bento-card h-full min-h-[200px]" data-testid={`firehub-${i}`}>
                  <span className="glow-blob" />
                  <span className="icon-badge">
                    <Icon className="h-5 w-5 text-[#F28C18]" strokeWidth={1.5} />
                  </span>
                  <h3 className="mt-6 font-serif-display text-2xl text-[#F6F0E6]">{t}</h3>
                  <p className="mt-2 text-[#D9D9D9] text-[14.5px] leading-relaxed">{b}</p>
                </div>
              </TiltCard>
            </Reveal>
          ))}
        </div>

        <Reveal delay={300}>
          <div className="mt-14 flex flex-col sm:flex-row items-center gap-4">
            <a href="#contact" className="btn-fire" data-testid="firehubs-cta">
              <Flame className="h-4 w-4" strokeWidth={1.7} />
              Learn About Fire Hubs
            </a>
            <a href="#updates" className="btn-ghost" data-testid="firehubs-cta-updates">
              Get Hub Announcements
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FireHubs;
